exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "ul[data-v-866002ec]{width:100%}hr[data-v-866002ec]{border:1px solid #718096;margin:0;top:8px;left:0;right:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}", ""]);
